import { render, staticRenderFns } from "./TableElement.vue?vue&type=template&id=6b2ba3a6&scoped=true&"
import script from "./TableElement.vue?vue&type=script&lang=js&"
export * from "./TableElement.vue?vue&type=script&lang=js&"
import style0 from "./TableElement.vue?vue&type=style&index=0&id=6b2ba3a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2ba3a6",
  null
  
)

export default component.exports